import Api from "utils/api";
import { decryptJSON } from "global/security";

const BASE = "/super_admin_v2/enterprises";

function ensurePayload(response) {
  if (!response?.success || !response?.data) {
    throw new Error(response?.message || "Enterprise data is unavailable");
  }

  const decrypted = decryptJSON(response.data);
  return decrypted;
}

async function postWorkspaceMailAction(path, fallbackMessage, expectEncrypted = false) {
  const { response, error } = await Api(path, "post");

  if (error) {
    throw new Error(error?.message || fallbackMessage);
  }

  if (expectEncrypted) {
    return ensurePayload(response);
  }

  return response;
}

export async function getEnterpriseAccountsV2() {
  const { response, error } = await Api(BASE, "get");

  if (error) {
    throw new Error(error?.message || "Failed to load enterprise accounts");
  }

  const decrypted = ensurePayload(response);
  return Array.isArray(decrypted) ? decrypted : [];
}

export async function createEnterpriseAccountV2(payload) {
  const { response, error } = await Api(BASE, "post", { payload });

  if (error) {
    throw new Error(error?.message || "Failed to create enterprise account");
  }

  return ensurePayload(response);
}

export async function updateEnterpriseAccountV2(accountId, payload) {
  const { response, error } = await Api(`${BASE}/${accountId}`, "put", {
    payload,
  });

  if (error) {
    throw new Error(error?.message || "Failed to update enterprise account");
  }

  return ensurePayload(response);
}

export async function getEnterpriseAccountDetailV2(accountId) {
  const { response, error } = await Api(`${BASE}/${accountId}`, "get");

  if (error) {
    throw new Error(error?.message || "Failed to load enterprise detail");
  }

  return ensurePayload(response);
}

export async function resendWorkspaceCreatePasswordV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/resend-create-password`,
    "Failed to send create password email"
  );
}

export async function resendWorkspaceWalletEmailV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/resend-wallet-email`,
    "Failed to send add to wallet email"
  );
}

export async function generateWorkspaceCreatePasswordLinkV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/generate-create-password-link`,
    "Failed to generate create password link",
    true
  );
}

export async function generateWorkspaceWalletLinkV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/generate-wallet-link`,
    "Failed to generate wallet link",
    true
  );
}
